import {checkedDeliveryIdentities,type IdentityDeliveryCheck,type IdentityDeliveryEntry} from './delivery.ts';
export type IdentityHandoverEntry=IdentityDeliveryEntry&{shipment_id:string;transport_id:string;source_handover_id:string|null;stop_id:number;assignment_revision:string;vehicle_id:string;driver_user_id:number};
export function checkedHandoverIdentities(entries:IdentityHandoverEntry[],raw:unknown):IdentityDeliveryCheck[]{
 const checks=checkedDeliveryIdentities(raw??[]);
 if(checks.length!==entries.length)throw new Error('Check every identity still carried by this van.');
 for(const check of checks){
  const entry=entries.find(e=>e.content_id===check.content_id);
  if(!entry||check.quantity!==entry.available)throw new Error('Count the full remaining quantity of each identity.');
  if(check.package_scan!==entry.package_label||check.serial_scan!==(entry.serial||'')||check.lot_scan!==(entry.lot||'')||check.expiry_scan!==(entry.expiry||''))throw new Error('The package, serial, batch or expiry scan does not match the carried goods.');
 }
 // Physical rescue preserves custody even for expired goods. Recipient delivery still checks expiry.
 return checks;
}
